import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import I18n from "i18n-js";
import { haveAccessToFeature } from "../utils";
import { hasMultiEntityEnabled } from "../constants";
import WelcomeToGrabMerchant from "../assets/images/onboarding/welcome-to-grabmerchant.png";
import GetLatestInsight from "../assets/images/onboarding/get-latest-insight.png";
import MakeFinancialReport from "../assets/images/onboarding/make-financial-report.png";
import SaveTimeOnMenu from "../assets/images/onboarding/save-time-on-menu.png";
import GrowYourSales from "../assets/images/onboarding/grow-your-sales.png";
import AccountStructureBanner from "../assets/images/onboarding/account_structure_banner.svg";
import "../assets/styles/onboarding.less";
import { Button, Carousel, Modal } from "@duxton-web/ui";

const getData = () => {
  let data = [
    {
      title: "mex-portalonboarding-001-001-heading",
      content: "mex-portalonboarding-001-002-body",
      imgSrc: WelcomeToGrabMerchant,
    },
    {
      title: "mex-portalonboarding-001-003-heading",
      content: "mex-portalonboarding-001-004-body",
      imgSrc: GetLatestInsight,
    },
    {
      title: "mex-portalonboarding-001-005-heading",
      content: "mex-portalonboarding-001-006-body",
      imgSrc: MakeFinancialReport,
    },
    {
      title: "mex-portalonboarding-001-007-heading",
      content: "mex-portalonboarding-001-008-body",
      imgSrc: SaveTimeOnMenu,
    },
    {
      title: "mex-portalonboarding-001-009-heading",
      content: "mex-portalonboarding-001-010-body",
      imgSrc: GrowYourSales,
    },
  ];
  if (haveAccessToFeature(hasMultiEntityEnabled)) {
    return data.concat([
      {
        title: "mex-portalonboarding-001-011-heading",
        content: "mex-portalonboarding-001-012-body",
        imgSrc: AccountStructureBanner,
      },
      {
        title: "mex-portalonboarding-001-013-heading",
        content: "mex-portalonboarding-001-014-body",
        imgSrc: AccountStructureBanner,
      },
    ]);
  }
  return data;
};

const OnboardingModal = (props) => {
  const { onClose } = props;
  const [step, setStep] = useState(0);

  const data = getData();

  const lastStep = data.length - 1;
  const carousel = useRef();

  const onClickLearnMore = () => {
    if (step === lastStep) {
      onClose();
      return;
    }
    carousel && carousel.current && carousel.current.next();
  };

  const onItemChange = (item) => {
    setStep(item);
  };

  return (
    <Modal
      backdropClosable={false}
      open={true}
      width={520}
      className="insights-onboarding-modal"
      onCancel={() => onClose()}
      destroyOnClose
      footer={null}
      zIndex={2000}
    >
      <div>
        <Carousel
          ref={carousel}
          afterChange={onItemChange}
          dots={{ className: "carousel-dot" }}
        >
          {data.map((item) => {
            return (
              <div key={item.title} className="img-container">
                <img
                  className="content-image"
                  src={item.imgSrc}
                  alt="tutorial content 1"
                />
              </div>
            );
          })}
        </Carousel>
        <div className="content-container">
          <div className="title">{I18n.t(data[step].title)}</div>
          <div className="content">{I18n.t(data[step].content)}</div>
        </div>
        <div
          className={`footer ${
            step === lastStep ? "one-button" : "two-buttons"
          }`}
        >
          {step !== lastStep && (
            <Button
              className="btn-skip"
              onClick={onClose}
              size="small"
              variant="ghost"
            >
              {I18n.t("mex-insightsv2-035-011-button")}
            </Button>
          )}
          <Button
            size="small"
            className="btn-learn-more"
            onClick={onClickLearnMore}
            type="primary"
          >
            {step === lastStep
              ? I18n.t("mex-insightsv2-035-013-button")
              : I18n.t("mex-insightsv2-035-012-button")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

OnboardingModal.propTypes = {
  onClose: PropTypes.func,
  visible: PropTypes.bool,
};

OnboardingModal.defaultProps = {
  visible: false,
  onClose: null,
};

export default OnboardingModal;
